// extracted by mini-css-extract-plugin
export default {"name":"aside_name__xz-6C","linkedin":"aside_linkedin__cF3H2","github":"aside_github__cjf8R"};